import React from "react";
import { useSelector } from "react-redux";
import { Draggable } from "react-beautiful-dnd";
import { getCurrentUser } from "../../reducers";
import { roleCheck } from "../../../../utils";
import { VIRTUAL_DRAFTING_MANAGER } from "../../../../utils/constants";
import VrDraftingJobServiceRow from "./VrDraftingJobServiceRow";

const DraggableVrDraftingJobServiceRow = ({
  jobService, index, setJobServices, reloadData
}) => {
  const currentUser = useSelector(getCurrentUser)
  const currentTeamRole = currentUser.attributes.current_team_role
  const systemRole = currentUser.attributes.role
  const isVirtualDraftingManager = roleCheck(systemRole, currentTeamRole, VIRTUAL_DRAFTING_MANAGER)
  const disableDrag = !isVirtualDraftingManager

  return (
    <Draggable
      draggableId={jobService?.id}
      index={index}
      isDragDisabled={disableDrag}>
      { provided => (
        <React.Fragment>
          { index === 10 && (
            <tr><td colSpan="100%" className="draggable-separate-line" /></tr>
          )}
          <tr
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}>
            <VrDraftingJobServiceRow
              key={jobService.id}
              disableDrag={disableDrag}
              jobService={jobService}
              reloadData={reloadData}
              index={index} />
          </tr>
        </React.Fragment>
      )}
    </Draggable>
  )
}

export default DraggableVrDraftingJobServiceRow